import { Layout } from "@/pages/layout";

export const Paused = () => {
  return (
    <Layout activeTab="home" sections={[]}>
      <div className="flex h-screen flex-col items-center justify-center">
        <div className="w-64">
          <img src="/logo.png" alt="Unbox Logo" />
        </div>
        <h1 className="mt-6 text-2xl font-semibold text-gray-900 dark:text-gray-50">Account paused</h1>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
          Your access to Unbox is currently paused. Please contact your account manager for further information.
        </p>
      </div>
    </Layout>
  );
};
